import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRounded: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-rounded, share, arrow, login"><path d="M2.75 7.75V19.25H19.25M16.75 4.25L20.25 7.75L16.75 11.25M7.75 13.75V12.75C7.75 9.98858 9.98858 7.75 12.75 7.75H19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowRounded;
